var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useLanguage } from '@base/LanguageProvider';
import { useTagActions } from '@data/tag/tagActions';
import { useTagContext } from '@data/tag/tagContext';
import { getTagDisplayName } from '@data/tag/tagUtil';
import { appColors } from '@styled/useTheme';
import React, { useEffect, useRef } from 'react';
import { AiOutlineLoading } from 'react-icons/ai';
import { IoMdCheckmark, IoMdClose } from 'react-icons/io';
import { useCreateSheetRow } from '../../data/sheetRow/sheetRowActions';
import { isAccountTag, isDimensionTag, isTableTag } from '../../data/tag/types';
import { useSelectedSheetRow } from '../../data/sheetRow/sheetRowHooks';
import { Plus } from '@shared/icons/icons';
import { useOutsideClick } from '@hooks/useOutsideClick';
export var FinderCreationWithAutocomplete = function (_a) {
    var onDone = _a.onDone, mode = _a.mode, setCreateMode = _a.setCreateMode;
    var inputRef = useRef(null);
    var _b = __read(React.useState(''), 2), title = _b[0], setTitle = _b[1];
    var _c = __read(React.useState(-2), 2), selectionIndex = _c[0], setSelectionIndex = _c[1];
    var _d = __read(React.useState(false), 2), pending = _d[0], setPending = _d[1];
    var L = useLanguage().L;
    var createMaterializedAccountTag = useTagActions().createMaterializedAccountTag;
    var tagData = useTagContext().tagData;
    var create = useCreateSheetRow();
    var sheetRow = useSelectedSheetRow();
    var targetRef = useRef(null);
    useOutsideClick(targetRef, function () { return setCreateMode('none'); });
    useEffect(function () {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [inputRef]);
    if (mode === 'none') {
        return null;
    }
    var searchResults = tagData.search(title);
    var suggestions = searchResults ? searchResults.slice(0, 5) : [];
    var parentId = sheetRow ? sheetRow.id : null;
    var parentDataReadonly = sheetRow ? sheetRow.sheetRow.readonly : false;
    var createObjectAndTag = function (name) { return __awaiter(void 0, void 0, void 0, function () {
        var tag;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPending(true);
                    return [4 /*yield*/, createMaterializedAccountTag(name)];
                case 1:
                    tag = _a.sent();
                    create.mutate({
                        name: name,
                        parentId: parentId,
                        readonly: parentDataReadonly,
                        accountTagId: isAccountTag(tag) ? tag.id : null,
                        tableTagId: null,
                        customColumns: [],
                        dimensionTagIds: [],
                        hierarchyFlatten: false,
                        hierarchyMaxDepth: 0,
                        withData: false,
                        predicate: null,
                    }, {
                        onSettled: function () {
                            setPending(false);
                            onDone();
                        },
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var createObjectWithoutTag = function (name) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setPending(true);
            create.mutate({
                name: name,
                parentId: parentId,
                readonly: parentDataReadonly,
                accountTagId: null,
                tableTagId: null,
                customColumns: [],
                dimensionTagIds: [],
                hierarchyFlatten: false,
                hierarchyMaxDepth: 0,
                withData: false,
                predicate: null,
            }, {
                onSettled: function () {
                    setPending(false);
                    onDone();
                },
            });
            return [2 /*return*/];
        });
    }); };
    var createObjectAndSelectTag = function (name, tag) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setPending(true);
            create.mutate({
                name: name,
                parentId: parentId,
                readonly: parentDataReadonly,
                accountTagId: isAccountTag(tag) ? tag.id : null,
                tableTagId: isTableTag(tag) ? tag.id : null,
                customColumns: [],
                dimensionTagIds: isDimensionTag(tag) ? [tag.id] : [],
                hierarchyFlatten: false,
                hierarchyMaxDepth: 0,
                withData: false,
                predicate: null,
            }, {
                onSettled: function () {
                    setPending(false);
                    onDone();
                },
            });
            return [2 /*return*/];
        });
    }); };
    var setItemTitle = function (newTitle) {
        setTitle(newTitle);
    };
    var onAutocompleteKeyUp = function (e) {
        if (e.key === 'Enter' && title) {
            if (selectionIndex === -2) {
                //create without tag
                createObjectWithoutTag(title);
            }
            else if (selectionIndex === -1) {
                //create new tag
                createObjectAndTag(title);
            }
            else if (selectionIndex > -1) {
                //tag is selected
                var tag = suggestions[selectionIndex];
                setItemTitle(tag.name);
                createObjectAndSelectTag(tag.name, tag);
            }
        }
    };
    var onAutocompleteKeyDown = function (e) {
        if (e.key === 'Escape') {
            //escape button
            onDone();
        }
        else if (e.key === 'ArrowUp' && selectionIndex === -2) {
            e.preventDefault();
        }
        else if (e.key === 'ArrowUp' && selectionIndex >= -1) {
            //up key
            e.preventDefault();
            var newIndex = selectionIndex - 1;
            setSelectionIndex(newIndex);
        }
        else if (e.key === 'ArrowDown' && selectionIndex < suggestions.length - 1) {
            //down key
            e.preventDefault();
            var newIndex = selectionIndex + 1;
            setSelectionIndex(newIndex);
        }
    };
    return (React.createElement("div", { ref: targetRef, className: "pfc" },
        pending && (React.createElement(AiOutlineLoading, { style: {
                marginTop: '4px',
                width: '24px',
                height: '24px',
                color: 'grey',
                alignSelf: 'center',
                animation: 'spinicon 1s linear infinite',
            } })),
        !pending && (React.createElement("div", { className: "pfc-autocomplete" },
            React.createElement("input", { onKeyUp: onAutocompleteKeyUp, onKeyDown: onAutocompleteKeyDown, ref: inputRef, autoComplete: "off", type: "text", name: "", placeholder: L('Create or Generate New Rows'), className: suggestions.length > 0 ? 'pfc-input-title' : 'pfc-input-title round-bottom', value: title, onChange: function (e) {
                    setItemTitle(e.target.value);
                } }),
            React.createElement("button", { className: "pfc-btn", style: { left: '270px' }, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (title) {
                            createObjectWithoutTag(title);
                        }
                        else {
                            if (inputRef.current) {
                                inputRef.current.focus();
                            }
                        }
                        return [2 /*return*/];
                    });
                }); } },
                React.createElement(IoMdCheckmark, { style: { height: '20px', width: '20px' } })),
            React.createElement("button", { className: "pfc-btn", style: { left: '235px', color: appColors.ui.dark }, onClick: function () {
                    onDone();
                } },
                React.createElement(IoMdClose, { style: { height: '20px', width: '20px' } })),
            title.length > 0 ? (React.createElement("div", { className: "autocomplete-items" },
                React.createElement("div", { className: title ? '' : 'hidden', onClick: function () {
                        if (title) {
                            createObjectAndTag(title);
                        }
                    }, style: selectionIndex === -1 ? { backgroundColor: '#fafafa' } : {} },
                    React.createElement("span", { style: {
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight: 'bold',
                            color: appColors.primary.w500,
                            lineHeight: '32px',
                        } },
                        React.createElement(Plus, { color: appColors.primary.w500 }),
                        " ",
                        L('Create New Variable'))),
                suggestions.map(function (tag, index) {
                    var tagName = getTagDisplayName(tag);
                    return (React.createElement("div", { onClick: function () {
                            createObjectAndSelectTag(tag.name, tag);
                        }, key: index, style: selectionIndex === index ? { backgroundColor: '#fafafa' } : {} },
                        React.createElement("span", { style: {
                                display: 'inline-block',
                                alignItems: 'center',
                                paddingLeft: '17px',
                                lineHeight: '32px',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                width: '232px',
                            } }, tagName),
                        React.createElement("input", { type: "hidden", value: tagName })));
                }))) : null))));
};
